import { memo } from 'react';

import PropTypes from 'prop-types';

import Typography from 'components/UI/Typography/Typography';

import { TOP_GAME_COLORS } from 'components/config/analytics';

import styles from './GameByGeo.module.scss';

const GameByGeo = ({
  name,
  icon,
  geo,
  backgroundColor = TOP_GAME_COLORS.byGeo[0],
  backgroundImage,
}) => (
  <div className={styles.root} style={{ backgroundColor, backgroundImage }}>
    <img src={icon} alt="game_icon" className={styles.icon} />
    <div>
      <Typography weight="semibold">{name}</Typography>
      <Typography type="text-sm" color="grey">
        Trending in {geo}
      </Typography>
    </div>
  </div>
);

GameByGeo.propTypes = {
  name: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  geo: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string,
  backgroundImage: PropTypes.string,
};

export default memo(GameByGeo);
